module.exports = __webpack_public_path__ + "files/95e724778978dcad299d3f4a00c12917.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/nature-4.png
// module id = 1608
// module chunks = 60